import React from 'react';
import {makeStyles} from '@material-ui/core';
import clsx from 'clsx';
import EducationIconList from './lists/educationIconList/EducationIconList';

const useStyles = makeStyles(theme => ({
    layoutOnPage: {
        marginBottom: '64px',
        display: 'flex',
    },
    layoutInMenu: {
        width: '100%',
        display: 'flex',
    },
    layoutLeft: {
        flex: 1,
    },
    layoutRight: {
        width: '380px',
        display: 'flex',
        flexDirection: 'column',
        '& > *': {
            '&:not(last-child)': {
                marginBottom: '32px',
            }
        }
    }
}));

export default function EducationContentBar(props) {
    const { isMenu } = props;
    const classes = useStyles();

    return (
        <div className={isMenu ? clsx(classes.layoutInMenu) : clsx('padding', classes.layoutOnPage)}>
            <div className={classes.layoutLeft}>
                <EducationIconList isMenu={false}/>
            </div>
        </div>
    );
}
